import { RawDraftContentBlock, RawDraftContentState } from '@ms/yammer-content-state';
import { v4 as uuidv4 } from 'uuid';

type GetNewBlockKey = () => string;
const getNewBlockKey: GetNewBlockKey = () => uuidv4().substring(0, 5);

type PrependTitleToRawContentState = (title: string, rawContentState: RawDraftContentState) => RawDraftContentState;
export const prependTitleToRawContentState: PrependTitleToRawContentState = (title, rawContentState) => {
  const titleBlock: RawDraftContentBlock = {
    key: getNewBlockKey(),
    type: 'unstyled',
    text: title,
    depth: 0,
    inlineStyleRanges: [],
    entityRanges: [],
  };

  const blocksWithTitle = [titleBlock, ...rawContentState.blocks];

  const updatedRawContentState: RawDraftContentState = {
    ...rawContentState,
    blocks: blocksWithTitle,
  };

  return updatedRawContentState;
};
